import React from 'react'
import { Text, Heading as H } from 'rebass'
import { keyframes, css } from 'styled-components'
import PropTypes from 'prop-types'

const childrenPropTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

const shine = keyframes`
  from, to {
    background-position: 100% top;
  }
  50% {
    background-position: 0% top;
  }
`

export const Bold = ({ children, ...rest }) => (
  <Text as="strong" {...rest}>
    {children}
  </Text>
)

export const Paragraph = ({ children, ...rest }) => (
  <Text as="p" {...rest}>
    {children}
  </Text>
)

export const Heading = ({ children, ...rest }) => (
  <H
    fontFamily="regular"
    fontSize={[4, 5, 6]}
    fontWeight="normal"
    as="h1"
    css={css`
      text-transform: uppercase;
      transform: translate(-0.175em);
      margin: 1em 0;
    `}
    {...rest}
  >
    {children}
  </H>
)

Heading.propTypes = {
  ...childrenPropTypes,
}

export const BigLetters = ({ children, noAnimation, ...rest }) => (
  <Text
    fontFamily="regular"
    color="red"
    fontSize={[4, 5, 6, '70px']}
    fontWeight="normal"
    {...rest}
    css={css`
      text-transform: uppercase;
      text-align: center;
      line-height: 1.1;
      text-indent: -0.175em;
      margin-bottom: 0.65em;
      padding-top: 0.175em;
      display: block;

      @supports (-webkit-background-clip: text) or (background-clip: text) {
        background: repeating-linear-gradient(
          44deg,
          rgba(247, 64, 58, 0.05) 20%,
          rgba(247, 64, 58, 0.9) 45%,
          rgba(247, 64, 58, 0.9) 55%,
          rgba(247, 64, 58, 0.05) 80%
        );
        background-size: 600% auto;
        background-repeat: repeat;

        word-break: break-word;

        background-clip: text;
        text-fill-color: transparent;
        -webkit-background-clip: text;
        ${noAnimation
          ? ''
          : css`
              -webkit-text-fill-color: transparent;
              animation: ${shine} 10s linear 3;
              animation-timing-function: ease-in-out;
              animation-direction: alternate;
            `}
        transition: all 150ms ease-in-out;
        a:hover & {
          background: transparent;
          text-fill-color: ${props => props.theme.colors.red};
          -webkit-text-fill-color: ${props => props.theme.colors.red};
        }
      }
      a {
        text-decoration: none;
        color: inherit;
        display: block;
        padding: 0 20px;
        transition: color 150ms ease-in-out;

        &:hover {
          color: ${props => props.theme.colors.redIntense};
        }
      }
    `}
  >
    {children}
  </Text>
)

Bold.propTypes = {
  ...childrenPropTypes,
}

Paragraph.propTypes = {
  ...childrenPropTypes,
}

BigLetters.propTypes = {
  ...childrenPropTypes,
}
